// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"e30b6d64","419":"0d9b282f","787":"5f6c452b"}[chunkId] + ".chunk.js";
};